
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

interface NewsItem {
  ID: number | string;
  IMAGE: string;
}

@Component
export default class NewsCarousel extends Vue {
  @Prop({ required: true, type: Array }) readonly homeNews!: NewsItem[];

  currentIndex = 0;

  handleClick(id: number | string, index: number): void {
    this.$emit("news-selected", id, index);
  }

  scrollLeft(): void {
    const container = this.$refs.scrollContainer as HTMLElement;
    const card = container.querySelector(".news-card") as HTMLElement;

    if (card) {
      const gap =
        parseInt(getComputedStyle(container).columnGap || "16", 10) || 16;
      const scrollAmount = card.offsetWidth + gap;
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    }
  }

  scrollRight(): void {
    const container = this.$refs.scrollContainer as HTMLElement;
    const card = container.querySelector(".news-card") as HTMLElement;

    if (card) {
      const gap =
        parseInt(getComputedStyle(container).columnGap || "16", 10) || 16;
      const scrollAmount = card.offsetWidth + gap;
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  }

  onScroll(): void {
    const container = this.$refs.scrollContainer as HTMLElement;
    const children = Array.from(
      container.querySelectorAll(".news-card")
    ) as HTMLElement[];

    const containerCenter = container.scrollLeft + container.offsetWidth / 2;
    let closestIndex = 0;
    let closestDistance = Infinity;

    children.forEach((child, index) => {
      const childCenter = child.offsetLeft + child.offsetWidth / 2;
      const distance = Math.abs(containerCenter - childCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    this.currentIndex = closestIndex;
  }
}
